/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsCloudAccount {
    getFixupPrototypeFunction() { return FilterOptionsCloudAccount.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsCloudAccount>): FilterOptionsCloudAccount {
        let obj = Object.assign(new FilterOptionsCloudAccount(), model);
        FilterOptionsCloudAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsCloudAccount>): FilterOptionsCloudAccount {
        if (!model) return null;
        return FilterOptionsCloudAccount.newInstance(<FilterOptionsCloudAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsCloudAccount) {
        if (!obj) return;

        models.FilterOptionsCloudAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsCloudAccount): boolean {
        Object.setPrototypeOf(obj, FilterOptionsCloudAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.native_details) {
            models.ServiceAccountNativeDetailsBase.fixupPrototype(this.native_details);
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Indicates the status of the cloud account in corestack
     */
    status: models.ServiceAccountStatus;

    /**
     * ID of the account
     */
    cloud_account_id: string;

    /**
     * Name of the account
     */
    cloud_account_name: string;

    /**
     * Currency for the account
     */
    currency: models.Currency;

    /**
     * Scope of the Cloud account
     */
    scope: models.ServiceAccountScope;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

    /**
     * ID of the parent account, if any
     */
    parent_id: string;

    /**
     * Native details of the account
     */
    native_details: models.ServiceAccountNativeDetailsBase;

    /**
     * Indicates if the account is still active in the cloud
     */
    is_active_in_cloud: boolean;

}
